import React from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import YellowButton from "../../common/buttons/YellowButton";
import Seo from "../../common/Seo";
import Footer from "../../navigation/Footer";
import {makeLink} from "../../common/languages-helper";
import "./Cennik.css";

interface CennikProps {
    loginFunction: any;
    isAuthenticated: boolean;
}

// Public pricing page ("Cennik"). Content mirrors the Figma "Cennik EMDR Online"
// frame: everyone is on the free tier and every currently available feature is
// included at no cost.
const Cennik: React.FC<CennikProps> = ({loginFunction, isAuthenticated}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const signUp = (event: any) =>
        loginFunction({authorizationParams: {screen_hint: "signup"}}, event);

    const features = [
        t("Creating individual sessions"),
        t("Invitation links for patients"),
        t("Visual bilateral stimulation available"),
        t("Access to technical support"),
        t("No payment card required"),
    ];

    return (
        <div className="cennik-page">
            <Seo
                title={t("EMDR Online Pricing")}
                description={t("Use EMDRlink for free — every currently available feature at no cost, no payment card required.")}
            />
            <div className="cennik-container">
                <span className="cennik-badge">{t("EMDR APP")}</span>
                <h1 className="cennik-title">{t("Use for free")}</h1>
                <p className="cennik-lead">
                    {t("We are developing EMDR Online together with therapists and are making all currently available features free of charge.")}
                </p>

                <div className="cennik-card">
                    <div className="cennik-card-head">
                        <h2 className="cennik-card-title">{t("How the account works")}</h2>
                        <span className="cennik-price">0&nbsp;zł</span>
                    </div>
                    <p className="cennik-card-subtitle">{t("All features available for free")}</p>

                    <ul className="cennik-features">
                        {features.map((f, i) => (
                            <li key={i} className="cennik-feature">
                                <CheckCircleIcon className="cennik-check" />
                                <span>{f}</span>
                            </li>
                        ))}
                    </ul>

                    {isAuthenticated ? (
                        <div className="cennik-cta cennik-cta-member">
                            <p className="cennik-member-note">
                                {t("You're already using EMDR Online — every feature is unlocked on your free account.")}
                            </p>
                            <YellowButton onClick={() => navigate(makeLink("/"))}>
                                {t("Go to your dashboard")}
                            </YellowButton>
                        </div>
                    ) : (
                        <div className="cennik-cta">
                            <YellowButton onClick={signUp}>{t("Sign Up")}</YellowButton>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Cennik;
